import { AuthenticatedUser } from 'auth/types/authenticated-user.type';
import { TokenResponse } from 'auth/types/token-response.type';
import { UserInfo } from 'auth/types/user-info.type';
import { Env } from 'types/env/Env.type';

export const mapUserAndTokenToAuthenticatedUser = (
  userInfo: UserInfo | undefined,
  token: TokenResponse | undefined,
  env: Env
): AuthenticatedUser | undefined => {
  if (!userInfo) return undefined;
  const badToken = !token || token.token_expiry_time < new Date();
  if (badToken) return undefined;

  return {
    accessToken: token?.access_token ?? '',
    accessTokenExpiry: token?.token_expiry_time ?? new Date(Date.now() + 86400 * 1000), // 24 hours from the current time
    guid: userInfo.guid,
    email: userInfo.email,
    login: userInfo.email,
    groups: userInfo.groups,
    nickname: userInfo.nickname,
    givenName: userInfo.given_name,
    familyName: userInfo.family_name,
    displayName: userInfo.display_name,
    phoneNumber: userInfo.phone_number,
    preferredUsername: userInfo.preferred_username,
    fullName: userInfo.name,
    username: userInfo.sub
  };
};
